import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-068ec766")

_pushScopeId("data-v-068ec766")
const _hoisted_1 = { class: "solution" }
const _hoisted_2 = { class: "kv forseo" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "SMARTAX System Best Tax Solutions", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, " Stop VAT & GST fraud will also help to increase the government’s income tax revenue. ", -1)
const _hoisted_5 = { class: "sec1" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("p", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("Why do you need"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("the SMARTAX Free-Fraud System?")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "content" }, [
    /*#__PURE__*/_createVNode("p", null, " Value-added tax (VAT) is also known as goods and services tax (GST) in somecountries and is a type of tax that is assessed incrementally. Taxes are collected from final consumers at various stages of production, distribution or sales of products and services, and are finally paid to the government and it is often manipulated or cheated by the collector. "),
    /*#__PURE__*/_createVNode("p", null, " The term “VAT/GST fraud” can cover many activities that result in the deprivation of government tax revenue. Unlike other taxes, the value-added tax has two separate areas where fraudsters can engage in fraudulent activities: not only can they manipulate their responsibilities to steal value-added tax, but they can also abuse the mechanism of value-added tax to evade income tax. "),
    /*#__PURE__*/_createVNode("p", null, " Basic VAT fraud arises when a business dishonestly fails to charge and account for VAT when they should have done so, or VAT is charged but not paid over to tax bureaus. "),
    /*#__PURE__*/_createVNode("p", null, " Under the serious fraud circumstances, SMARTAX is here with Tax fraud-free System! ")
  ])
], -1)
const _hoisted_7 = { class: "sec2 forseo" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "What can we do?", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, " SMARTAX is to provide an efficient and reliable system to encourage voluntary compliance with VAT regulations, which will be linked to the merchant’s POS system and will provide the tax bureau with real-time data on the company’s total sales and VAT collected. ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, " This initiative is in line with the government’s objective of implementing an efficient and reliable system to stop tax fraud and evasion. ", -1)
const _hoisted_11 = { class: "sec3" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Increase tax revenue"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("with SMARTAX System Solutions")
], -1)
const _hoisted_14 = { class: "tab-block" }
const _hoisted_15 = { class: "tab-nav" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("SMARTAX "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("TAX BI")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("AIVAT® "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("System")
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Data-Driven "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Decisions")
], -1)
const _hoisted_22 = { class: "tab-content" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "tab-title hidden-maxmin tab tab1" }, [
  /*#__PURE__*/_createVNode("i"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode("SMARTAX "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("TAX BI")
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("p", null, " SMARTAX TAX BI with AIVAT® provides the tax bureau with historical, current, and forecast data analysis of tax collection operations, including processing a large amount of structured and unstructured data to help identity, formulate and create new government strategies and policies. ", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, " Its functions include real-time monitoring, reporting, online analytical processing, analysis, complex event processing, tax performance management, benchmarking, predictive analysis, and descriptive analysis. The government can use these functions to support various tax decision-making strategies from complex operations to basic operational decisions. ", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "tab-title hidden-maxmin tab tab2" }, [
  /*#__PURE__*/_createVNode("i"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode("AIVAT® "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("System")
  ])
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("p", null, " AIVAT® System (Artificial Intelligent Value Added Tax System) is a data analytical system that gathers tax related data for analysis to forecast the trend of the national economy growth in order to help the government to measure, implement or modify tax policies. AIVAT® System also provides data exchange service among different departments level within the country therefore it resolves the issue of data exchange between government departments to solve the data isolation. ", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "tab-title hidden-maxmin tab tab3" }, [
  /*#__PURE__*/_createVNode("i"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Data-Driven "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("Decisions")
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, " Our value-driven data approach enables the tax bureau to use powerful analysis and actionable insights to support the future development of the government projects, based on smart data-driven decisions. ", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("p", null, " We ensure full compliance with tax authorities' requirements, and our proprietary technology enables the government to fully control, view and monitor VAT or GST transaction data from multiple angles. ", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "sec4 forseo" }, [
  /*#__PURE__*/_createVNode("p", null, "Safety and integrity are our core business responsibilities."),
  /*#__PURE__*/_createVNode("p", null, " We take pride in maintaining the highest level of data integrity and security. ")
], -1)
const _hoisted_32 = { class: "sec5" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "left" }, " EECOMM fully complies with the following SOC Type II guidelines and standards in our comprehensive systems and procedures to protect all data and systems to ensure continuous security at all levels of VAT and GST collections. "),
  /*#__PURE__*/_createVNode("div", { class: "right" }, [
    /*#__PURE__*/_createVNode("ol", null, [
      /*#__PURE__*/_createVNode("li", null, "All data is processed within the country’s territory."),
      /*#__PURE__*/_createVNode("li", null, "EECOMM is SOC Type II compliant standards with annual auditing.")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GridLine = _resolveComponent("GridLine")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_GridLine),
      _hoisted_3,
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_GridLine, { class: "hide2 hide3 hide4 hide5" }),
      _hoisted_6
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_GridLine, { class: "hide2 hide4 hide5" }),
      _hoisted_8,
      _hoisted_9,
      _hoisted_10
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_GridLine),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode("ul", _hoisted_15, [
            _createVNode("li", {
              class: ["tab tab1", {'active': _ctx.currentTab === 0}],
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabClick(0)))
            }, [
              _hoisted_16,
              _hoisted_17
            ], 2),
            _createVNode("li", {
              class: ["tab tab2", {'active': _ctx.currentTab === 1}],
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabClick(1)))
            }, [
              _hoisted_18,
              _hoisted_19
            ], 2),
            _createVNode("li", {
              class: ["tab tab3", {'active': _ctx.currentTab === 2}],
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tabClick(2)))
            }, [
              _hoisted_20,
              _hoisted_21
            ], 2)
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("div", {
              class: ["tab1-content", {'active': _ctx.currentTab === 0}]
            }, [
              _hoisted_23,
              _hoisted_24,
              _hoisted_25
            ], 2),
            _createVNode("div", {
              class: ["tab2-content", {'active': _ctx.currentTab === 1}]
            }, [
              _hoisted_26,
              _hoisted_27
            ], 2),
            _createVNode("div", {
              class: ["tab3-content", {'active': _ctx.currentTab === 2}]
            }, [
              _hoisted_28,
              _hoisted_29,
              _hoisted_30
            ], 2)
          ])
        ])
      ])
    ]),
    _hoisted_31,
    _createVNode("div", _hoisted_32, [
      _createVNode(_component_GridLine),
      _hoisted_33
    ])
  ]))
})